<div class="select-payment-dialog">
  <div class="dialog-header">
    <h2 class="dialog-title">Selecciona método de pago</h2>
    <fa-icon [icon]="faX" class="close-btn" (click)="close()"></fa-icon>
  </div>

  <div class="method-options">
    <div class="method-pill" (click)="goToPaymentMethod('cash')">
      <fa-icon [icon]="faCoins" class="method-icon"></fa-icon>
      <span>Pago en efectivo</span>
    </div>
    <div class="method-pill" (click)="goToPaymentMethod('tpv')">
      <fa-icon [icon]="faCreditCard" class="method-icon"></fa-icon>
      <span>Pago con tarjeta</span>
    </div>
  </div>
</div>